import React, { Ref } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { copyToClipboard } from 'features/transaction-details/helpers';

interface CopyableFieldRowProps {
	label: string;
	value: string;
	/** Valor que se copia al portapapeles (si difiere del mostrado) */
	copyValue?: string;
	onCopied?: (message: string) => void;
	monospace?: boolean;
	copyButtonRef?: Ref<HTMLButtonElement>;
}

export const CopyableFieldRow = ({
	label,
	value,
	copyValue,
	onCopied,
	monospace = true,
	copyButtonRef,
}: CopyableFieldRowProps): JSX.Element => {
	const handleCopy = async (): Promise<void> => {
		const textToCopy = copyValue ?? value;
		const success = await copyToClipboard(textToCopy);
		if (success) {
			onCopied?.(`${label} copiado`);
		}
	};

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 1,
				py: 0.75,
				px: 1,
				borderRadius: 1,
				bgcolor: 'grey.50',
				border: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Box sx={{ minWidth: 0, flex: 1 }}>
				<Typography variant="caption" color="text.secondary" display="block">
					{label}
				</Typography>
				<Typography
					variant="body2"
					fontWeight="medium"
					sx={{
						fontFamily: monospace ? 'monospace' : 'inherit',
						wordBreak: 'break-all',
					}}
				>
					{value || '—'}
				</Typography>
			</Box>
			<Tooltip title={`Copiar ${label.toLowerCase()}`}>
				<span>
					<IconButton ref={copyButtonRef} size="small" onClick={handleCopy} disabled={!value || value === '—'}>
						<ContentCopyIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
		</Box>
	);
};
